import React from "react";
import styled from "styled-components";
import FooterColumn from "./FooterColumn";
import PText from "./PText";

const FooterStyles = styled.div`
  padding-top: 10rem;
  background-color: var(--deep-dark);
  .container {
    display: flex;
    gap: 3rem;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }
  .copyright {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      margin-left: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

const Footer = () => {
  return (
    <FooterStyles>
      <div className="container">
        <div className="footer__col1">
          <h1 className="footer__col1__title">Tanvir Ahmed</h1>
          <PText>
            I am a Software Developer passionate about crafting innovative web
            experiences, specialized in designing and developing solutions that
            engage users and bring ideas to life.
          </PText>
        </div>
        <div className="footer__col2">
          <FooterColumn
            heading="Important Links"
            links={[
              { title: "Home", path: "/", type: "Link" },
              { title: "About", path: "/about", type: "Link" },
              { title: "Projects", path: "/projects", type: "Link" },
              { title: "Contact", path: "/contact", type: "Link" },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterColumn
            heading="Contact Info"
            links={[
              { title: "+8801738372627", path: "tel:+8801738-372627" },
              {
                title: "tanvirahmed1418@gmail.com",
                path: "mailto:tanvirahmed1418@gmail.com",
              },
              {
                title: "Latifpur, Bogura Sadar, Bogura, Bangladesh",
                path: "https://www.google.com/maps/place/Colony,+Bogura/@24.8236351,89.3719661,15z/data=!4m5!3m4!1s0x39fc54963113667b:0x5fb88958f3c48e10!8m2!3d24.8228368!4d89.3819521",
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterColumn
            heading="Social Links"
            links={[
              {
                title: "Linkedin",
                path: "https://www.linkedin.com/in/tanvir1418",
              },
              {
                title: "GitHub",
                path: "https://github.com/tanvir1418",
              },
              {
                title: "Facebook",
                path: "https://www.facebook.com/tanvir1418",
              },
              {
                title: "Twitter",
                path: "https://www.twitter.com/tanvir1418",
              },
            ]}
          />
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <PText>&copy; 2022 - Tanvir Ahmed | Designed By Tanvir</PText>
        </div>
      </div>
    </FooterStyles>
  );
};

export default Footer;
